<ng-container wp-isolated-query-space>
  <wp-embedded-table #embeddedTableForConfiguration
    [queryProps]="locals.currentQuery || {}"
    [configuration]="{ tableVisible: false }">
  </wp-embedded-table>
</ng-container>
